export default __webpack_public_path__ + "static/media/docx-icon.fc44a55a.png";